<template>
  <!--------Teaching section Start-------->
  <div id="teaching" class="page">
    <div class="pageheader">
      <div class="headercontent">
        <div class="section-container">

          <h2 class="title">Jobs</h2>

          <div class="row">
            <div class="col-md-12">
              <p></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pagecontents">
      <div class="section color-1">
        <div class="section-container">
          <div class="row">
            <div class="title text-center">
              <h3>Current Job</h3>
            </div>
            <ul class="ul-dates">
              <li>
                <div class="dates">
                  <span>Present</span>
                  <span>2021(Dec)</span>
                </div>
                <div class="content">
                  <h4>Sr. Software Engineer</h4>
                  <p><em>StylZmedia LTD.</em>, Dhaka, Bangladesh</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="section color-2">
        <div class="section-container">
          <div class="row">
            <div class="title text-center">
              <h3>Job History</h3>
            </div>
            <ul class="ul-dates-gray">
              <li>
                <div class="dates">
                  <span>2021(Nov)</span>
                  <span>2021(Jan)</span>
                </div>
                <div class="content">
                  <h4>Sr. Software Engineer</h4>
                  <p><em>United IT Solution LTD.</em>, Dhaka, Bangladesh</p>
                </div>
              </li>
              <li>
                <div class="dates">
                  <span>2020(Dec)</span>
                  <span>2020(Jul)</span>
                </div>
                <div class="content">
                  <h4>Software Engineer</h4>
                  <p><em>United IT Solution LTD.</em>, Dhaka, Bangladesh</p>
                </div>
              </li>
              <li>
                <div class="dates">
                  <span>2020(Apr)</span>
                  <span>2019(Sep)</span>
                </div>
                <div class="content">
                  <h4>Fullstack Developer(Part Time)</h4>
                  <p><em>iSchool</em>, Green Road, Dhaka, Bangladesh</p>
                </div>
              </li>
              <li>
                <div class="dates">
                  <span>2019(Sep)</span>
                  <span>2019(Mar)</span>
                </div>
                <div class="content">
                  <h4>Fullstack Developer(Freelance)</h4>
                  <p><em>AbeerFood</em>,Stockholm, Sweden</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--------Teaching section end-------->
</template>
<script>
export default {
  name: 'Teaching',
}
</script>